/**
 * Audit Log Page
 *
 * Complete history of all compliance actions with chain verification.
 */

import React from 'react';
import { AuditLogPage as AuditLogPageComponent } from '../audit';

export default function AuditLogPage() {
  return <AuditLogPageComponent />;
}
